import POSTS_VIEW_OPTIONS from '../../util/constants.js'

export default function () {
  return {
    // GLOBAL
    isLoading: false,
    // SETTINGS
    settings: null,
    // expo or careerwise
    client: null,
    // user info: manager/admin
    user: null,
    userAccess: false,
    templateView: 'Homepage',
    // timer
    idleTimer: new Date(), // @todo default to null, then dispatch action to init
    idleTimerClosed: false,

    // POSTS/MEDIA
    currentPost: null,
    currentPostsTemplateId: null,
    filterPostsBy: {
      keywords: null,
      category: null,
      year: null,
      tag: null,
      industry: null,
      draft: null,
    },
    postsView: POSTS_VIEW_OPTIONS.DEFAULT,
    filterResourceBy: {
      keywords: null,
      type: null,
    },
  }
}
